import { Component, OnInit, Input, Output, EventEmitter , ChangeDetectorRef } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';

@Component({
  selector: 'app-dtable-rotations',
  templateUrl: './dtable-rotations.component.html',
  styleUrls: ['./dtable-rotations.component.scss']
})
export class DtableRotationsComponent implements OnInit {
  @Input() activityId:any;
  @Input() rotations: any;
  @Input() hasEditPermission : boolean;
  @Input() rootScopeData : RootScopeDeclare;
  @Output() onComplete: EventEmitter<any> = new EventEmitter();
  @Output() onDismiss: EventEmitter<any> = new EventEmitter();
  fiteredRotations = [];
  paginationInfo:{currentPage:number,rowsPerPage:number} = {currentPage:1,rowsPerPage:5};
  constructor(private cdr:ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  paginationChanged(event:any){
    const from = (event.currentPage * event.rowsPerPage) - event.rowsPerPage;
    const to = event.currentPage * event.rowsPerPage;
    this.fiteredRotations = this.rotations.slice(from,to);
    this.paginationInfo = event;
  }

  complete(rotation:any){
    rotation.activityId = this.activityId;
    this.onComplete.emit(rotation);
  }

  dismiss(rotation:any){
    rotation.activityId = this.activityId;
    this.onDismiss.emit(rotation);
  }

  ngAfterViewInit(){
    this.cdr.detectChanges();
  }
}
